import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workFlowStagePipe'
})
export class WorkFlowStagePipe implements PipeTransform {

  transform(
    value: string,
    args: { useRole: number | undefined; type: 'Notice' | 'Search' }
  ): string {
    switch (value) {
      case '1':
        return 'WorkflowStage.1';
      case '2':
        return 'WorkflowStage.2';
      case '3':
        return 'WorkflowStage.3';
      case '4':
        return 'WorkflowStage.4';
      case '5':
        return 'WorkflowStage.5';
      case '6':
        return 'WorkflowStage.6';
      case '7':
        return 'WorkflowStage.7';
      default:
        return '';
    }
  }

}
